import {Component, Input} from '@angular/core';
import {AttributeType, DetailAttribute, IoniconsOutline, ND} from '@pt/pt-models';


@Component({
  selector: 'pt-details-attribute-viewer',
  template: `
    <div class='d-flex align-items-center lh-sm'>
      <div [ngClass]='attribute.valueIcon.iconClass'
           *ngIf='attribute.valueIcon && !attribute.valueIcon.hide &&
           (attribute.valueIcon.position === "left" || attribute.valueIcon.position === null || attribute.valueIcon.position === undefined)'>
        <pt-icon class="hstack" [key]='attribute.valueIcon.key'
                 [iconType]='attribute.valueIcon.type'
                 [size]='attribute.valueIcon.size ? attribute.valueIcon.size : fontSize'
        ></pt-icon>
      </div>

      <ng-container [ngSwitch]='attribute.type'>
        <div class="align-self-end" *ngSwitchCase='AttributeType.STRING'
             [innerText]="attribute.value | replaceNullWithText: ND">
        </div>

        <div class="align-self-end" *ngSwitchCase='AttributeType.ASYNC'>
          {{ (attribute.value | async) ? (attribute.value | async) : ND }}
        </div>

        <div class="align-self-end" *ngSwitchCase='AttributeType.DATE'>
          {{ (attribute.value | localizedDate: {defaultValue: ND}) }}
        </div>

        <div class="align-self-end" *ngSwitchCase='AttributeType.BOOLEAN'>
          <pt-icon class='checked' *ngIf='attribute.value === true' [key]='IconCheck'></pt-icon>
          <span *ngIf='attribute.value === false'>{{ "LABELS.NO" | translate }}</span>
          <span *ngIf='attribute.value === null || attribute.value === undefined'>{{ ND }}</span>
        </div>

        <div class="align-self-end" *ngSwitchCase='AttributeType.HTML'>
          <div [innerHTML]='attribute.value'></div>
        </div>

        <div class="align-self-end" *ngSwitchDefault>
          {{ attribute.value | replaceNullWithText: ND }} <b ngbTooltip="'Undefined type '{{attribute?.type}}">?</b>
        </div>
      </ng-container>

      <div [ngClass]='attribute.valueIcon.iconClass'
           *ngIf='attribute.valueIcon && !attribute.valueIcon.hide && attribute.valueIcon.position === "right"'>
        <pt-icon [key]='attribute.valueIcon.key'
                 [iconType]='attribute.valueIcon.type'
                 [size]='attribute.valueIcon.size ? attribute.valueIcon.size : fontSize'
        ></pt-icon>
      </div>
    </div>
  `
})
export class DetailsAttributeViewerComponent {
  @Input() attribute: DetailAttribute;

  IconCheck = IoniconsOutline.check;
  IconUnCheck = IoniconsOutline.minus;
  AttributeType = AttributeType;
  fontSize = 12;
  ND = ND;

}
